import Variable from '../../constants/constants.json';

const { createRequest } = require('../../api/client');

export const getFeatureEngagementList = (data) => {
    const options = {
        url: `${Variable.backendUrl}/featureEngagement/list`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: data,
    };

    return createRequest(options);
};

export const getTimeEngagementList = (data) => {
    const options = {
        url: `${Variable.backendUrl}/featureEngagement/time/list`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: data,
    };

    return createRequest(options);
};